import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatCurrency, getCurrencySymbol } from '../../../utils/currency';

const PortfolioSummary = ({ totalAssets, totalLiabilities, totalCash, netWorth }) => {
  const currencySymbol = getCurrencySymbol();

  const summaryCards = [
    {
      label: 'Total Assets',
      value: totalAssets,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Total Liabilities',
      value: totalLiabilities,
      icon: 'TrendingDown',
      color: 'text-error',
      bgColor: 'bg-error/10',
      suffix: ' owed'
    },
    {
      label: 'Cash on Hand',
      value: totalCash,
      icon: 'Wallet',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Net Worth',
      value: netWorth,
      icon: 'DollarSign',
      color: netWorth >= 0 ? 'text-success' : 'text-error',
      bgColor: netWorth >= 0 ? 'bg-success/10' : 'bg-error/10'
    }
  ];

  return (
    <div className="bg-card rounded-lg p-20 md:p-24 shadow-elevation-3 mb-32 md:mb-40">
      <div className="flex items-center mb-20 md:mb-24">
        <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
          <Icon name="PieChart" size={24} color="var(--color-primary)" strokeWidth={2.5} />
        </div>
        <h2 className="ml-12 text-xl md:text-2xl font-heading font-semibold text-card-foreground">
          Portfolio Summary
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-16 md:gap-20">
        {summaryCards?.map((card, index) => (
          <div 
            key={index}
            className="bg-background rounded-lg p-16 md:p-20 border border-border hover:shadow-elevation-2 transition-smooth"
          >
            <div className="flex items-center justify-between mb-12">
              <p className="text-xs md:text-sm text-muted-foreground font-caption">
                {card?.label}
              </p>
              <div className={`flex items-center justify-center w-10 h-10 ${card?.bgColor} rounded-lg`}>
                <Icon 
                  name={card?.icon} 
                  size={20} 
                  color={`var(--color-${card?.color?.replace('text-', '')})`}
                  strokeWidth={2}
                />
              </div>
            </div>
            <p className={`text-xl md:text-2xl font-heading font-bold ${card?.color}`}>
              {formatCurrency(card?.value)}{card?.suffix || ''}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioSummary;